<nav class="breadcrumb">
  <ul class="breadcrumb-list font-size-xs">
    <li class="breadcrumb-item">
      <a
        class="breadcrumb-link"
        [routerLink]="
          competitorID() &&
          productID() &&
          productSeriesID() &&
          routerPathParams().includes('arguments')
            ? `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/arguments/${productID()}`
            : competitorID() &&
                productID() &&
                productSeriesID() &&
                routerPathParams().includes('tech-data')
              ? `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/tech-data/${productID()}`
              : argumentID() && productID() && productSeriesID()
                ? `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/arguments/${productID()}`
                : productID() && productSeriesID()
                  ? `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}`
                  : `/pia/${countryID()}/${languageID()}/${year()}/product-info`
        "
      >
        <claas-icon
          [iconId]="'659468'"
          [namespace]="'pia'"
          [size]="18"
          [alt]="''"
          [removeDefaultColor]="true"
        ></claas-icon>
      </a>
    </li>
    <li class="breadcrumb-item">
      <a
        class="breadcrumb-link"
        routerLink="/"
        routerLinkActive="breadcrumb-link-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ "pia.features.product-overview.prefix-headline" | translate }}
      </a>
    </li>
    <li class="breadcrumb-item">
      <a
        class="breadcrumb-link"
        [routerLink]="`/pia/${countryID()}/${languageID()}/${year()}/product-info`"
        routerLinkActive="breadcrumb-link-active"
      >
        {{ "features.product-overview.headline" | translate }}
      </a>
    </li>
    @if (!contacts()) {
      <li class="breadcrumb-item">
        <a
          [ngClass]="{
            'breadcrumb-link': true,
            'breadcrumb-link-active': !productID(),
          }"
          [routerLink]="`/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}`"
        >
          {{ productSeriesName() }}
        </a>
      </li>
    }
    @if (productID()) {
      <li class="breadcrumb-item">
        <a
          [ngClass]="{
            'breadcrumb-link': true,
            'breadcrumb-link-active': !competitorID(),
          }"
          [routerLink]="
            routerPathParams().includes('arguments')
              ? `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/arguments/${productID()}`
              : `/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/tech-data/${productID()}`
          "
        >
          {{ productName() }}
        </a>
      </li>
    }
    @if (competitorID()) {
      <li class="breadcrumb-item">
        <a
          [ngClass]="{
            'breadcrumb-link': true,
            'breadcrumb-link-active': competitorID(),
          }"
          [routerLink]="`/pia/${countryID()}/${languageID()}/${year()}/product/${productSeriesID()}/arguments/${productID()}`"
        >
          {{ "features.product-comparison.headline" | translate }}
        </a>
      </li>
    }
    @if (contacts()) {
      <li class="breadcrumb-item">
        <a
          [ngClass]="{
            'breadcrumb-link': true,
            'breadcrumb-link-active': competitorID(),
          }"
          [routerLink]="`/pia/${countryID()}/${languageID()}/${year()}/contacts}`"
        >
          {{ "features.contacts.contactsMainTitle" | translate }}
        </a>
      </li>
    }
  </ul>
</nav>
